/* app/js/src/components/monitoring/chart/monitoring-chart.component.scss */
img,
div {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=monitoring-chart.component.css.map */
